module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrTimeWrapStyle))
  }, [_c('div', {
    staticClass: "time-dot-wrap",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined))
  }, [_c('div', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrTimeBoxStyle))
  }, [_c('text', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrTimeTextStyle))
  }, [_vm._v(_vm._s(_vm.countDownData.hour))])]), _vm._v(" "), _c('div', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrDotBoxStyle))
  }, [_c('text', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrDotTextStyle))
  }, [_vm._v(_vm._s(_vm.tplObj().firstDot))])]), _vm._v(" "), _c('div', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrTimeBoxStyle))
  }, [_c('text', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrTimeTextStyle))
  }, [_vm._v(_vm._s(_vm.countDownData.minute))])]), _vm._v(" "), _c('div', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrDotBoxStyle))
  }, [_c('text', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrDotTextStyle))
  }, [_vm._v(_vm._s(_vm.tplObj().secondDot))])]), _vm._v(" "), _c('div', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrTimeBoxStyle))
  }, [_c('text', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.mrTimeTextStyle))
  }, [_vm._v(_vm._s(_vm.countDownData.second))])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8dcc12f8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dcc12f8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-countdown/index.vue
// module id = 50
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28